import { serializable, alias, primitive, object } from "serializr";
import moment from "moment";
import { Assignment } from "../Assignment/assignment.model";
export class Report {
  @serializable(alias("id", primitive()))
  id?: number;

  @serializable(alias("report_id", primitive()))
  reportId?: number;

  @serializable(alias("report_template_id", primitive()))
  reportTemplateId?: number;

  @serializable(alias("content", primitive()))
  content?: string;

  @serializable(alias("case_detail_id", primitive()))
  caseDetailId?: number;

  @serializable(alias("assignment_id", primitive()))
  assignmentId?: number;

  @serializable(alias("status", primitive()))
  status?: boolean;

  @serializable(alias("report_title", primitive()))
  reportTitle?: string;

  @serializable(alias("ai_plugin", primitive()))
  aiPlugin?: boolean;

  @serializable(alias("assignment", object(Assignment)))
  assignment?: Assignment;

  @serializable(alias("report_name", primitive()))
  reportName?: string;

  @serializable(alias("reported_doctor", primitive()))
  reportedDoctor?: string;

  @serializable(alias("created_at", primitive()))
  createdAt?: string;

  @serializable(alias("updated_at", primitive()))
  updatedAt?: string;

  getReportName() {
    if(this.reportName && this.updatedAt) {
      return `${this.reportName}_${moment(this.updatedAt).format('DD MMM YYYY')}`
    }
  }
}
